// Header.js

import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import '../css/Header.css'; // Path to your CSS file
import ThemeSwitcher from './ThemeSwitcher';
import logoImage from '../assets/image/logo1.webp';
import { useUser } from '../contexts/UserContext';
import { CiUser } from "react-icons/ci";

function Header() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('isDarkMode');
    if (savedTheme === null) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    return savedTheme === 'true';
  });
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false); 

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkMode);
    document.body.classList.toggle('light-mode', !isDarkMode);
    localStorage.setItem('isDarkMode', isDarkMode.toString());
  }, [isDarkMode]);

  const handleToggleTheme = () => {
    setIsDarkMode(prevMode => !prevMode);
  };
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove the token from localStorage
    setUser(null); // Update user state to null
    navigate('/');
  };
  const handlePublicProfile = () => {
    navigate(`/user/${user.username}`);
    setShowDropdown(false);
  };
  const handleEditProfile = () => {
    navigate(`/profile`);
    setShowDropdown(false);
  };

  return (
    <header className="site-header">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/" className="brand-link">
            <img src={logoImage} alt="Website Logo" className="website-logo" />
            <span className="website-name">InterviewBlogs</span>
          </Link>
        </div>
        <ul className="nav-links">
          <li><NavLink to="/">Interviews</NavLink></li>
          {user && <li><NavLink to="/add-article">Share</NavLink></li>}
          <li><a target="_blank" rel="noreferrer" href="https://h1bdata.info">H1B Info</a></li>
          <li><a target="_blank" rel="noreferrer" href="https://www.jobseekr.io/">Jobs</a></li>
        </ul>
        <ul className="auth-links">
        {user ? (
          <>
            <li className="welcome-copy">Hi, {user.username}</li>
            <li>
              <div className="avatar-container" onClick={toggleDropdown}>
                <CiUser size="2em" />
                {showDropdown && (
                  <ul className="dropdown-menu">
                    <li>
                      <div className="dropdown-item" onClick={handlePublicProfile}>
                        Public Profile
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-item" onClick={handleEditProfile}>
                        Edit Profile
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </div>
                    </li>
                  </ul>
                )}
              </div>
            </li>
          </>
          ) : (
            <>
              <li><NavLink to="/login">Log in</NavLink></li>
              <li><NavLink className="signup-link" to="/signup">Sign up</NavLink></li>
            </>
          )}
          <li className="theme-switcher">
            <ThemeSwitcher isDarkMode={isDarkMode} onToggle={handleToggleTheme} />
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
